<template>
  <a-popover
    trigger="click"
    placement="bottom"
    overlay-class-name="objective-alignment-tabs"
  >
    <template #content>
      <a-tabs v-model:activeKey="activeKey">
        <a-tab-pane
          key="ALIGN_OTHER"
          :tab="$t('okr.list.alignOthers')"
        >
          <AlignOther
            :entity="entity"
            v-bind="$attrs"
          />
        </a-tab-pane>
        <a-tab-pane
          key="ALIGN_INVITATION"
          :tab="$t('okr.list.inviteToAlign')"
        >
          <AlignInvitation
            :entity="entity"
            v-bind="$attrs"
          />
        </a-tab-pane>
      </a-tabs>
    </template>
    <a-space
      class="clickable objective-align"
      @click.stop
    >
      <IconFont
        type="iconduiqi"
        class="icon-block"
      />
      {{ $t('shared.align') }}
    </a-space>
  </a-popover>
</template>

<script>
import { ref } from 'vue'

import AlignOther from './AlignOther'
import AlignInvitation from './AlignInvitation'

export default {
  name: 'AlignDialog',
  components: {
    AlignOther,
    AlignInvitation
  },
  inheritAttrs: false,
  props: {
    entity: {
      type: Object,
      required: true
    }
  },
  setup () {
    const getPopupContainer = trigger => {
      return trigger
    }
    return {
      getPopupContainer,
      activeKey: ref('ALIGN_OTHER')
    }
  }
}
</script>
